import React, { useEffect, useState } from "react";
import ModalComponent from "../../../../features/ModalComponent";
import { Ticket } from "../../../models/Ticket";
import useCalendarSale from "../../CalendarSale/hooks/useCalendarSale";
import FutureTicketChange from "./changeDate";
import useFutureTickets from "./hooks/useFutureTickets";
import NewDateChoose from "./newDateChoose";
import "./style.scss";
import TicketExercise from "./ticketExercise";
import TicketNoExercise from "./ticketNoExercise";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";
import TicketExerciseMobile from "./ticketExerciseMobile";
import TicketNoExerciseMobile from "./ticketNoExerciseMobile";
import QrCodeModal from "../../../../features/QRcode";
import { useTranslation } from "react-i18next";

interface IProps {
  ticket: Ticket;
  refreshTickets: Function;
}

const FutureTicket: React.FC<IProps> = ({ ticket, refreshTickets }: IProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [openChangeDate, setOpenChangeDate] = useState(false);
  const [openDayChoose, setOpenDayChoose] = useState(false);
  const [passId, setPassId] = useState<number>(999);
  const [exerciseId, setExerciseId] = useState<number>(999);
  const isDesktop = useDesktopSize();

  const { getAssignByTicket, alertCalendar } = useCalendarSale();
  const { resignFromExercise, alert } = useFutureTickets();

  const handleSetPassId = (passId: number) => {
    setPassId(passId);
  };
  const handleSetExerciseId = (exerciseId: number) => {
    setExerciseId(exerciseId);
  };

  const handleSetOpen = () => {
    setOpen(!open);
  };
  const handleSetOpenChangeDate = () => {
    setOpenChangeDate(!openChangeDate);
  };
  const handleSetOpenDayChoose = () => {
    setOpenDayChoose(!openChangeDate);
  };

 
  return (
    <React.Fragment>
      {ticket.passtype === 2 && ticket.ticket === true && (
        <div className="">
          {ticket.exercises[0] ? (
            <React.Fragment>
              {isDesktop ? (
                <TicketExercise
                  ticket={ticket}
                  handleSetOpenChangeDate={handleSetOpenChangeDate}
                  handleSetOpen={handleSetOpen}
                />
              ) : (
                <TicketExerciseMobile
                  ticket={ticket}
                  handleSetOpenChangeDate={handleSetOpenChangeDate}
                  handleSetOpen={handleSetOpen}
                />
              )}
            </React.Fragment>
          ) : (
            <React.Fragment>
              {isDesktop ? (
                <TicketNoExercise ticket={ticket} handleSetOpenDayChoose={handleSetOpenDayChoose} />
              ) : (
                <TicketNoExerciseMobile ticket={ticket} handleSetOpenDayChoose={handleSetOpenDayChoose} />
              )}
            </React.Fragment>
          )}
        </div>
      )}

      {open && (
        <ModalComponent
          footer={false}
          open={open}
          closeModal={() => setOpen(false)}
          title={t("kod_qr")}
          onAccept={() => setOpen(false)}
        >
          <QrCodeModal trhId={ticket.trhId} name={ticket.name} />
          <button
            onClick={() => setOpen(!open)}
            className="button big padding-medium button-fill-second  center-button"
          >
            {t("gotowe_schowaj")}
          </button>
        </ModalComponent>
      )}

      {openChangeDate && (
        <ModalComponent
          footer={true}
          open={openChangeDate}
          acceptText={t("zrezygnuj")}
          closeModal={() => setOpenChangeDate(false)}
          title={t("zmiana_terminu")}
          onAccept={() => {
            resignFromExercise(ticket.exercises[0].objectId);
            refreshTickets();
            // setTimeout(() => {
            if (alert.length < 2) {
              setOpenChangeDate(false);
            }
            // }, 600);
          }}
        >
          <FutureTicketChange ticket={ticket} alert={alert} />
        </ModalComponent>
      )}

      {openDayChoose && (
        <ModalComponent
          footer={true}
          open={openDayChoose}
          acceptText={t("zatwierdz_date")}
          closeModal={() => setOpenDayChoose(false)}
          title={t("wybor_terminu")}
          onAccept={() => {
            getAssignByTicket(passId, exerciseId);
            setTimeout(() => {
              if(alertCalendar.length < 3){
                setOpenDayChoose(false);
                refreshTickets();
              }
            }, 2000);
          }}
        >
          <NewDateChoose ticket={ticket} handleSetExerciseId={handleSetExerciseId}  handleSetPassId={handleSetPassId} alertCalendar={alertCalendar} />
        </ModalComponent>
      )}
    </React.Fragment>
  );
};

export default FutureTicket;
